import { LoginService } from 'app/services/login/login.service';
import { Component, ViewChild } from '@angular/core';
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup} from '@angular/forms';
import { EmpresasService } from '../../services/empresas/empresas.service';
import {HttpErrorResponse } from '@angular/common/http';
import { MessagesTitles, MessagesStatus } from '../../models/messages';
import Swal from "sweetalert2";
import { environment } from 'environments/environment';
@Component({
  selector: 'app-ref-bancarias',
  templateUrl: './ref-bancarias.component.html',
  styleUrls: ['./ref-bancarias.component.scss'],
  providers:[MessagesTitles, MessagesStatus]
})
export class RefBancariasComponent{

  Label_RefBancarias=environment.LABEL_REF_BANCARIAS;
  razSocial : string;
  rucEmpresa:any;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  pageSizeOptions = [10,20,30,50,100,200];
  refBancarias:any = [];
  loading:boolean=false;
  IdCuenta:string;
  idEmpresa:string;
  statusId:string;
  dataEnviar:any={};
  formularioRefBancarias : FormGroup;
  displayedColumns: string[] = 
            ['checked','Estado','Banco_Dsc','Moneda_Dsc','Tipo_de_Cuenta_Dsc','NroCuenta','CCI'];
  dataSource = new MatTableDataSource( this.refBancarias) ;
  abrirAgregarRefBancarias : boolean = false;
  tipoServicio:any;
  ruta:any;
  constructor(private activateRoute :ActivatedRoute,
     private empresasService:EmpresasService ,
     private router :Router,
     private msgTitulos : MessagesTitles,
     private msgStatus:MessagesStatus,
     private loginService:LoginService) {

      this.tipoServicio = this.empresasService.tipoServicio          
      if (this.tipoServicio == undefined) {
        let rutas = this.router.url.split("/",3);
        this.ruta = rutas[2];
        if (this.ruta == 'proveedor') {
          this.loginService.clickGuard = true;
          this.router.navigate(['/empresas/proveedor/listado']);
        } else if (this.ruta == 'inversor') {
          this.loginService.clickGuard = true;
          this.router.navigate(['/empresas/inversor/listado']);
        } else {
          this.loginService.clickGuard = true;
          this.router.navigate(['/empresas/adquirente/listado']);
        }
      }
      this.activateRoute.params.subscribe( params => {
      this.idEmpresa =params['id'];
      this.obtenerReferenciasBancarias(this.idEmpresa);
    })
   }
   ngOnInit() {
    let rutas = this.router.url.split("/",3);
    this.ruta = rutas[2];
     
  }
   Regresar(id:any=this.rucEmpresa){
    if (this.ruta == 'proveedor') {
      this.loginService.clickGuard = true;
      this.router.navigate(['/empresas/proveedor/listado/',id]);
    } else if (this.ruta == 'inversor') {
      this.loginService.clickGuard = true;
      this.router.navigate(['/empresas/inversor/listado']);
    }else {
      this.loginService.clickGuard = true;
      this.router.navigate(['/empresas/adquirente/listado/',id]);
    }
    }

  obtenerReferenciasBancarias(id:string){
    this.formularioRefBancarias = new FormGroup({});
    this.loading=true;
    this.empresasService.obtenerReferenciasBancariasEmpresa(id)
    .subscribe(res => {
      this.refBancarias = res;
    /*  this.refBancarias = this.refBancarias.filter(
        state => state.Tipo_Servicio == this.tipoServicio
      );*/
      this.razSocial = sessionStorage.getItem('razSocial');
      this.rucEmpresa=sessionStorage.getItem('rucEmpresa');
      this.loading = false;
      this.dataSource = new MatTableDataSource( this.refBancarias);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;

    },(err: HttpErrorResponse)=> {
      this.loading=false;
      if (err.error instanceof ErrorEvent) {
        console.error("Error Event");
    } else {
        this.msgStatus.getMessage(err.status);            
    }
      Swal.fire({
        title: this.msgTitulos.Error,
        text: "REFERENCIA BANCARIA NO OBTENIDO. "+this.msgStatus.message ,
        type: "error",
        allowOutsideClick: true,
        heightAuto: false
      })
    });

  }

  eliminarRefereciaBancaria(id:string,banco:string,numero:string){
       Swal.fire({
      title: '',
      text: '¿Estás seguro de dar de baja la cuenta bancaria de '+banco+' - '+numero+'?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, dar de baja',
      cancelButtonText: 'No, cancelar.',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {

        this.empresasService.eliminarReferenciaBancaria(id)
        .subscribe(res => { 
          Swal.fire(
            '¡La cuenta bancaria ha sido dado de baja en el sistema!',
            res["message"],
            'success'
          ).then(resp => {
            if (resp.value == true) {
              this.obtenerReferenciasBancarias(this.idEmpresa);
            }
          });
    
        },(err: HttpErrorResponse)=> {
          if (err.error instanceof ErrorEvent) {
            console.error("Error Event");
        } else {
            this.msgStatus.getMessage(err.status);            
        }
          Swal.fire({
            title: this.msgTitulos.Error,
            text: "NO SE ELIMINÓ C.B. "+this.msgStatus.message ,
            type: "error",
            allowOutsideClick: true,
            heightAuto: false
          })
        })
      } else if (result.dismiss === Swal.DismissReason.cancel )
       {
         this.loading = false;
       }
    })
  }
 
  cambiarCuentaPredeterminada(ele){
    Swal.fire({
   title: '',
   text: '¿Estás seguro de marcar como predeterminado?',
   type: 'warning',
   showCancelButton: true,
   confirmButtonText: 'Si, Marcar predeterminado',
   cancelButtonText: 'No, cancelar.',
   reverseButtons: true,
   heightAuto: false
 }).then((result) => {
   if (result.value) {
    this.dataEnviar.Tipo_Servicio = ele.Tipo_Servicio
    this.dataEnviar.Moneda = ele.Moneda;
    this.dataEnviar.FlgPredeterminado = '1';
    Swal.fire({
      title: 'Espere',
      text:'Actualizando Información!!',
      type:'info',
      allowOutsideClick:false,
      heightAuto: false
    });
    Swal.showLoading();
    this.empresasService.cambiarCuentaPredeterminada(this.dataEnviar,ele.idCuenta)
    .subscribe(res => {
      Swal.fire({
        title: 'Success',
        text: "Cuenta bancaria predeterminada cambiada con éxito! ",
        type: "success",
        heightAuto: false
      }).then(respu => {
        if (respu.value == true) {
          this.obtenerReferenciasBancarias(this.idEmpresa);
        }
      });  
      this.loading = false;
    },(err: HttpErrorResponse)=> {
      this.loading = false;
      if (err.error instanceof ErrorEvent) {
        console.error("Error Event");
    } else {
        this.msgStatus.getMessage(err.status);            
    }
      Swal.fire({
        title: this.msgTitulos.Error,
        text: "Referencia bancaria no actualizada. "+this.msgStatus.message ,
        type: "error",
        allowOutsideClick: true,
        heightAuto: false
      })
    })
   } else if (result.dismiss === Swal.DismissReason.cancel )
    {
      this.loading = false;
    }
 })
}

  crearReferenciaBancaria(){
    this.IdCuenta = "";
    this.abrirAgregarRefBancarias = true;
  }
  editarRefereciaBancaria(id:string){
    this.IdCuenta = id;
    this.abrirAgregarRefBancarias = true;
  }

  CerrarPopUpRefBancarias(){
    this.abrirAgregarRefBancarias = false;
    this.obtenerReferenciasBancarias(this.idEmpresa);
   
 }

}
